export const TextArrayItemTypes = {
    STEP_TAG: 'step_tag',
    PLACE_TAG: 'place_tag',
    USER_TAG: 'user_tag',
    TEXT: 'text',
};
